import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const NotificationDetailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    // Get notif from navigation state (passed from list)
    const notif = location.state?.notif;

    // If no state (e.g. direct URL access), show fallback
    if (!notif) {
        return (
            <div style={{ padding: "30px", maxWidth: "700px", margin: "0 auto" }}>
                <button
                    onClick={() => navigate("/notifications")}
                    style={{ background: "none", border: "none", cursor: "pointer", fontSize: "14px", color: "#6b7280", marginBottom: "20px" }}
                >
                    <i className="fa-solid fa-arrow-left"></i> Back to Notifications
                </button>
                <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px" }}>
                    Notification not found.
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: "30px", maxWidth: "700px", margin: "0 auto" }}>

            {/* Back Button */}
            <button
                onClick={() => navigate("/notifications")}
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    color: "#6b7280",
                    marginBottom: "24px",
                    padding: 0,
                }}
            >
                <i className="fa-solid fa-arrow-left"></i>
                Back to Notifications
            </button>

            {/* Detail Card */}
            <div style={{
                background: "white",
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                overflow: "hidden",
            }}>
                {/* Card Top Header */}
                <div style={{
                    padding: "20px 24px",
                    borderBottom: "1px solid #e5e7eb",
                    background: notif.is_read ? "#f9fafb" : "#f0fdf4",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111" }}>
                            {notif.title}
                        </h2>
                        <p style={{ margin: "6px 0 0", fontSize: "13px", color: "#9ca3af" }}>
                            <i className="fa-regular fa-clock" style={{ marginRight: "5px" }}></i>
                            {notif.created_at}
                        </p>
                    </div>
                    <span style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: notif.is_read ? "#16a34a" : "#dc2626",
                        background: notif.is_read ? "#dcfce7" : "#fef2f2",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        whiteSpace: "nowrap",
                    }}>
                        {notif.is_read ? "✓ Read" : "● Unread"}
                    </span>
                </div>

                {/* Employee Info */}
                {notif.employee && (
                    <div style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #e5e7eb",
                        background: "#fafafa",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                    }}>
                        <div style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #10b981, #14b8a6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontWeight: "700",
                            fontSize: "18px",
                            flexShrink: 0,
                        }}>
                            {notif.employee.first_name?.charAt(0)?.toUpperCase()}
                        </div>
                        <div>
                            <div style={{ fontWeight: "600", fontSize: "15px", color: "#111" }}>
                                {notif.employee.first_name} {notif.employee.last_name}
                            </div>
                            <div style={{ fontSize: "12px", color: "#9ca3af" }}>Employee</div>
                        </div>
                    </div>
                )}

                {/* Full Description */}
                <div style={{ padding: "24px" }}>
                    <h4 style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#9ca3af",
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        marginBottom: "12px",
                        margin: "0 0 12px 0",
                    }}>
                        Message
                    </h4>
                    <p style={{
                        fontSize: "15px",
                        color: "#374151",
                        lineHeight: "1.8",
                        margin: 0,
                        background: "#f9fafb",
                        padding: "18px",
                        borderRadius: "8px",
                        border: "1px solid #f3f4f6",
                    }}>
                        {notif.description}
                    </p>
                </div>

                {/* Footer */}
                <div style={{
                    padding: "14px 24px",
                    borderTop: "1px solid #e5e7eb",
                    background: "#f9fafb",
                    display: "flex",
                    justifyContent: "flex-end",
                }}>
                    <button
                        onClick={() => navigate("/notifications")}
                        style={{
                            background: "#10b981",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            fontSize: "13px",
                            fontWeight: "600",
                            cursor: "pointer",
                        }}
                    >
                        ← Back to List
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationDetailPage;